import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { CreateSSOProviderData, Saml2Provider } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function ssoProvider(config) {
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(Saml2Provider)),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Saml2Provider))),
    });
    return Object.freeze({
        /**
         * Register a new SSO Provider in this instance.
         *
         * Users will be able to login using the registered provider.
         *
         * The request should contain two files. One named `json` containing the json data explained below and one named `logo` containing the backup logo.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The just created provider.
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/sso_providers/`, createResponse.v, JSON.stringify(CreateSSOProviderData.encode(requestBody)));
            return result;
        },
        /**
         * Get all the SSO providers.
         *
         * @param arg The arguments to the function.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns The SSO providers, paginated.
         */
        getAll: async ({ pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/sso_providers/`, getAllResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
    });
}
